import React, { useEffect, useState } from 'react';

import { MenuItem, Select } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { StyledBox, StyledGrid, StyledPaper } from 'styles/common';

import Growth from 'assets/images/illustrations/growth.png';

import { goToGrowthTabularPage } from 'constants/helper';

import { Typography12, Typography11, Typography13, Typography16, Typography17 } from 'uiToolkit/Typography';

import {
  useJobFunctionCreationContext,
  useJobFunctionsDataContext,
  useSelectedJobFunctionContext,
} from './GrowthSettings';

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    zIndex: 10,
  }),
  container: (provided) => ({
    ...provided,
    marginTop: '9px',
  }),
};
export const StyledFunctionSelect = styled(Select)`
  width: 240px;
  height: 40px;

  font-size: 14px;

  .MuiMenu-paper {
    max-height: 50vh;
    overflow-y: scroll;
  }
  .MuiSelect-outlined {
    padding: 0.5rem 1rem;

    background-color: white !important;

    &:focus {
      background-color: white !important;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${(props) => props.theme.palette.primary.main} !important;
  }

  .MuiSelect-icon {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

const StyledPaper2 = styled(StyledPaper)`
  .MuiAutocomplete-option {
    padding-bottom: 0px;
    padding-top: 0px;
  }
`;

export const JobFunctionContainer = ({ handleNewJobFunctionCreation }) => {
  const history = useHistory();
  const { jobFunctions, reloadJobFunctionsList } = useJobFunctionsDataContext();
  const { openJobFunctionCreationModal } = useJobFunctionCreationContext();

  const { setSelectedJobFunction } = useSelectedJobFunctionContext();

  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  // option should be of shape { value: '', label: '' }

  const handleChange = (ev) => {
    const selectedValue = ev.target.value;

    if (selectedValue === 'create-new') {
      handleNewJobFunctionCreation();
    } else {
      const matchedJobFunction = jobFunctions.find(({ uuid }) => uuid === selectedValue);
      setSelectedJobFunction(matchedJobFunction);
      goToGrowthTabularPage(history, selectedValue);
      // selectJobFunction(matchedJobFunction);
    }
  };

  function populateOptions(jobFunctions) {
    setOptions(jobFunctions.map(({ uuid, name }) => ({ value: uuid, label: name })));
  }

  useEffect(() => {
    if (jobFunctions) populateOptions(jobFunctions);
  }, [jobFunctions]);

  return (
    <div>
      <Typography11 color="#333" bottomGutter={2} weight={600}>
        Select Job Function
      </Typography11>
      <Typography12 color="#666" bottomGutter={5}>
        Please select job function to add corresponding attributes
      </Typography12>

      <StyledFunctionSelect
        fullWidth
        displayEmpty
        variant="outlined"
        id="job-function-select"
        placeholder="Select"
        value=""
        onChange={handleChange}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        <MenuItem value="" disabled style={{ display: 'none' }}>
          <Typography13 color="primary"> Select </Typography13>
        </MenuItem>
        {jobFunctions.map(({ uuid, name }) => (
          <MenuItem value={uuid} style={{ padding: '0rem 1.5rem' }}>
            <StyledBox width="100%" padding="1rem 0" fontSize="14px" style={{ borderBottom: '1px solid #EAEAEA' }}>
              {name}
            </StyledBox>
          </MenuItem>
        ))}
        {/* <MenuItem value={'create-new'} style={{ padding: '0rem 1.5rem' }}>
          <StyledGrid
            container
            alignItems="center"
            justify="flex-start"
            style={{
              padding: '1rem 0',
              fontSize: '14px'
            }}
          >
            <StyledIconV2
              size="fixed10px"
              containerSize="fixed24px"
              circularOutline
              color="primary"
            >
              <PlusIcon2 />
            </StyledIconV2>
            <Typography13 color="primary" leftGutter={1.5}>
              Add New
            </Typography13>
          </StyledGrid>
        </MenuItem> */}
      </StyledFunctionSelect>
    </div>
  );
};

const LandingPage = () => {
  const history = useHistory();

  const { openJobFunctionCreationModal } = useJobFunctionCreationContext();
  const { reloadJobFunctionsList } = useJobFunctionsDataContext();
  const { setSelectedJobFunction } = useSelectedJobFunctionContext();

  const handleNewJobFunctionCreation = () => {
    openJobFunctionCreationModal((res) => {
      reloadJobFunctionsList();
      setSelectedJobFunction(res);
      goToGrowthTabularPage(history, res.uuid);
    });
  };

  return (
    <>
      <StyledGrid container justify="space-between">
        <div>
          <Typography16 bottomGutter={1.5}>Roles & Responsibilities</Typography16>
          <Typography17 bottomGutter={3}>Please select job function to add corresponding attributes</Typography17>
        </div>
        {/* <ButtonFilled
          style={{ width: '160px', height: '40px' }}
          onClick={handleNewJobFunctionCreation}
        >
          Add New Function
        </ButtonFilled> */}
      </StyledGrid>
      <StyledPaper elevation={0} showBorder style={{ padding: '6.5rem', paddingLeft: '12rem' }}>
        <StyledBox display="inline-grid" alignItems="center" gridTemplateColumns="auto auto" gridColumnGap="5rem">
          <img width="180px" height="180px" src={Growth} alt="growth-illustration" />
          <JobFunctionContainer handleNewJobFunctionCreation={handleNewJobFunctionCreation} />
        </StyledBox>
      </StyledPaper>
    </>
  );
};

export default LandingPage;
